import React from "react";
import "../Page.css";
import "./style.css";
import google_search_logo from "../../Assets/integration/google_search_console.svg"
import googleAds from "../../Assets/integration/google-ads.svg";
import KeyValueBox from "./keyValueBox/keyValueBox";
import CodeBox from "./codeBoxComponent/codeBox";

const GoogleAds = () => {
  
  return (
    <div className="DashboardPage" style={{ alignItems: "start", justifyContent: "start" }}>
      <div className="component-card">
        <div className="header_integration">
          <div className="name_header_int">
            
            <div className="int_heading_content">
            <h4>Google Ads</h4>
              <span className="active_state active">Active</span>
              
            </div>
            
          </div>
          <img className="int_logo" src={googleAds} />
          
        </div>

        <div className="params_int">
        <KeyValueBox hideContent={false}  label={"Conversion ID"} value={"YOUR_VERIFICATION_CODE_HERE"} />
        <KeyValueBox hideContent={false}  label={"Conversion Label"} value={"YOUR_VERIFICATION_CODE_HERE"} />
        <KeyValueBox hideContent={false}  label={"Value"} value={"YOUR_VERIFICATION_CODE_HERE"} />
        <KeyValueBox hideContent={false}  label={"Currency"} value={"YOUR_VERIFICATION_CODE_HERE"} />
        <KeyValueBox hideContent={false}  label={"Transaction ID"} value={"YOUR_VERIFICATION_CODE_HERE"} />
        </div>
      </div>
    </div>
  );
};

export default GoogleAds;